import { createFeatureSelector } from "@ngrx/store";
import { InstallationState } from "./installation-state";

export const selectInstallation =
  createFeatureSelector<InstallationState>("installation");
